import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders, UrlKind, ValidatedUrlModule_create } from "./HttpV2.js";
import { singleton } from "./fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "./fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "./fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { string_type, equals } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { int32ToString, uncurry } from "./fable_modules/fable-library.3.7.20/Util.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "./fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "./fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { printf, toText } from "./fable_modules/fable-library.3.7.20/String.js";
import { ActiveSessionResponse } from "./Model.js";

export function loadSelectedLanguage(language) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, "/SelectLanguage/" + language));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(string_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadSelectedRole(clientNr, invoiceeNrOpt) {
    let arg_1;
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, (arg_1 = ((invoiceeNrOpt == null) ? "" : (int32ToString(invoiceeNrOpt) + "/")), toText(printf("/SelectRole/%i/%s"))(clientNr)(arg_1))));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(string_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function checkActiveSession() {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, "/Session/"));
    if (matchValue.tag === 1) {
        return singleton.Return(new ActiveSessionResponse(2, matchValue.fields[0]));
    }
    else {
        return singleton.Delay(() => singleton.Bind(Http_send(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))), (_arg) => {
            const response = _arg;
            const matchValue_1 = response.statusCode | 0;
            switch (matchValue_1) {
                case 200: {
                    return singleton.Return(new ActiveSessionResponse(0, response.responseText));
                }
                case 401: {
                    return singleton.Return(new ActiveSessionResponse(1, response.responseText));
                }
                default: {
                    return singleton.Return(new ActiveSessionResponse(2, response.responseText));
                }
            }
        }));
    }
}

